module.exports = __webpack_public_path__ + "img/send.635594ad.svg";